import { render, staticRenderFns } from "./GroupParticipantsModal.vue?vue&type=template&id=118cefc8"
import script from "./GroupParticipantsModal.vue?vue&type=script&lang=js"
export * from "./GroupParticipantsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports